import React from "react";
import { Trans } from "react-i18next";

const SpecialGifts = ({ content }) => {
  return (
    <>
      {content?.edges?.length > 0 && (
        <div id="earn-referral-special-gifts">
          <div className="container">
            <h2 className="text-center mb-5">
              <Trans
                i18nKey="earnReferral.specialGifts.title"
                components={[<span>Gifts</span>]}
              />
            </h2>
            <div className="d-flex flex-wrap justify-content-center justify-content-lg-around">
              {content.edges.map(({ node }) => (
                <div className="card d-flex flex-column text-center m-2 mb-md-3">
                  <img
                    className="mx-3 align-self-center"
                    src={node.acfPartials.pIcon.localFile.publicURL}
                    alt={node.acfPartials.pHeading}
                    objectFit="contain"
                  />
                  <p>{node.acfPartials.pHeading}</p>
                </div>
              ))}
            </div>
            <div className="note ml-4 mt-4">
              <i>
                <Trans
                  i18nKey="earnReferral.specialGifts.note"
                  components={[]}
                />
              </i>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SpecialGifts;
